import React from 'react';

import { addReactError } from '@datadog/browser-rum-react';
import { createRoot } from 'react-dom/client';

import Screens from './screens';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container, {
    onUncaughtError: (error, errorInfo) => {
      // Report uncaught errors to Datadog
      addReactError(error as Error, errorInfo);
      // eslint-disable-next-line no-console
      console.error('Uncaught error:', error, errorInfo);
    },
    onCaughtError: (error, errorInfo) => {
      // Report caught errors to Datadog
      addReactError(error as Error, errorInfo);
      // eslint-disable-next-line no-console
      console.error('Caught error:', error, errorInfo);
    },
    onRecoverableError: (error, errorInfo) => {
      // Report recoverable errors to Datadog
      addReactError(error as Error, errorInfo);
      // eslint-disable-next-line no-console
      console.warn('Recoverable error:', error, errorInfo);
    }
  });

  root.render(<Screens />);
}
